import MuiButton from './MuiButton';
import MuiCardActions from './MuiCardActions';
import MuiCardContent from './MuiCardContent';
import MuiCardHeader from './MuiCardHeader';
import MuiChip from './MuiChip';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiLinearProgress from './MuiLinearProgress';
import MuiListItem from './MuiListItem';
import MuiListItemIcon from './MuiListItemIcon';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTableRow from './MuiTableRow';
import MuiToggleButton from './MuiToggleButton';
import MuiTypography from './MuiTypography';
import MuiListItemText from './MuiListItemText'
import MuiTextField from './MuiTextField'
import MuiInputLabel from './MuiInputLabel'
import MuiFormHelperText from './MuiFormHelperText'
import MuiMenuItem from './MuiMenuItem'
import MuiToolbar from './MuiToolbar'
import MuiDrawer from './MuiDrawer'
import MuiModal from './MuiModal'
import MuiPickersYear from './MuiPickersYear'
export default {
  // components: {
    MuiPickersYear,
    MuiModal,
    MuiMenuItem,
    MuiDrawer,
    MuiToolbar,
    MuiInputLabel,
  MuiButton,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiChip,
  MuiIconButton,
  MuiInputBase,
  MuiLinearProgress,
  MuiListItem,
  MuiListItemIcon,
  MuiOutlinedInput,
  MuiPaper,
  MuiTableCell,
  MuiTableHead,
  MuiTableRow,
  MuiToggleButton,
  MuiTypography,
  MuiListItemText,
  MuiTextField,
  MuiFormHelperText
  // }
};
